import { createSelector } from 'reselect';

import { getSelectedStructure } from '@sophocles/features/sites/slices/selectedStructure/selectors';

export const cicStatusSelector = state => state.entities.cicStatuses;

export const getCicStatusForSelectedStructure = createSelector(
  getSelectedStructure,
  cicStatusSelector,
  (site, statuses) => {
    const cic_id = site.getIn(['cic', 'id'], 0);
    return statuses.find(status => status.get('cic', -1) == cic_id, null, null); // either get the status or return null;
  },
);
